import { computed, ref } from 'vue'

export const useFilteredOptions = (sourceFn) => {
  const query = ref('')
  const source = computed(sourceFn)
  const options = computed(() => source.value.filter(option => !query.value || option.name?.toLowerCase().includes(query.value)))
  const onFilter = (value, update) => update(() => { query.value = value.toLowerCase() })
  return { options, onFilter }
}
